module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/seller/sub-component/kitchen/kitchen-details/kitchen-details.component.scss
// module id = ./src/app/seller/sub-component/kitchen/kitchen-details/kitchen-details.component.scss
// module chunks = main